// extracted by mini-css-extract-plugin
export default {"wrap":"aH-z","subtitle":"bH-z","contentWrap":"cH-z","imgWrap":"dH-z","heading":"eH-z","copy":"fH-z"};